<template>
   <div class="progress-bar" :style="progressStyle">
     <div class="progress-bar-fill" :style="fillStyle"></div>
     <div class="progress-bar-text">{{ progress }}</div>
   </div>
 </template>
<script>
export default{
   props: {
    progress: {
      type: Number,
      required: true
    },
    width: {
      type: Number,
      default: 200
    },
    height: {
      type: Number,
      default: 20
    },
    bgColor: {
      type: String,
      default: '#f0f0f0'
    },
    fillColor: {
      type: String,
      default: '#1abc9c'
    }
  },
  computed: {
    progressStyle () {
      return {
        width: `${this.width}px`,
        height: `${this.height}px`,
        backgroundColor: this.bgColor
      }
    },
    fillStyle () {
      return {
        width: `${this.progress}%`,
        height: `${this.height}px`,
        backgroundColor: this.fillColor
      }
    },
    token () {
      return this.$store.getters.getToken
    }
   },
}
</script>

<style>
.progress-bar{
  display: inline-block;
  border-radius: 4px;
  overflow: hidden;
}

.progress-fill {
  display: inline-block;
  transition: width 0.5s;
}

.progress-bar-text {
  display: inline-block;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/ProgressBar.vue